import React from 'react';
import { LinkOnComponent } from 'app/components/links/link';
import MatchRowTeaserTeamImage from 'app/components/matchRow/teaser/team/MatchRowTeaserTeamImage';
import MatchRowTeaserResult from 'app/components/matchRow/teaser/MatchRowTeaserResult';
import { TeamName, TeamNames, TeamResult, Wrapper } from 'app/components/matchRow/teaser/teaserStyles';
import styled from 'styled-components';
import { COLORS, FONTS, SIZES } from '@fupa/fupa-uikit';
const TestMatchMarker = styled.div.withConfig({
  componentId: "sc-4vml7s-0"
})(["position:absolute;top:0;left:0;width:", ";height:", ";overflow:hidden;border-top-left-radius:0.25rem;&::before{content:'';position:absolute;top:0;right:0;width:0;height:0;border-right:", " solid transparent;border-top:", " solid ", ";}&::after{content:'T';position:absolute;left:0.25rem;color:", ";font-size:", ";font-weight:", ";}"], SIZES[20], SIZES[20], SIZES[20], SIZES[20], COLORS.grey, COLORS.white, FONTS[10], FONTS.bold);
export default function MatchRowTeaser(_ref) {
  let {
    match
  } = _ref;
  const isTestMatch = match.test;
  return /*#__PURE__*/React.createElement(Wrapper, {
    as: LinkOnComponent,
    to: match.getLink(),
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "MatchRowTeaser",
    "data-sentry-source-file": "MatchRowTeaser.tsx"
  }, isTestMatch && /*#__PURE__*/React.createElement(TestMatchMarker, {
    "data-testid": "test-match-marker-element"
  }), /*#__PURE__*/React.createElement(TeamResult, {
    "data-sentry-element": "TeamResult",
    "data-sentry-source-file": "MatchRowTeaser.tsx"
  }, /*#__PURE__*/React.createElement(MatchRowTeaserTeamImage, {
    team: match.homeTeam,
    "data-sentry-element": "MatchRowTeaserTeamImage",
    "data-sentry-source-file": "MatchRowTeaser.tsx"
  }), /*#__PURE__*/React.createElement(MatchRowTeaserResult, {
    matchResult: match.result,
    "data-sentry-element": "MatchRowTeaserResult",
    "data-sentry-source-file": "MatchRowTeaser.tsx"
  }), /*#__PURE__*/React.createElement(MatchRowTeaserTeamImage, {
    team: match.awayTeam,
    "data-sentry-element": "MatchRowTeaserTeamImage",
    "data-sentry-source-file": "MatchRowTeaser.tsx"
  })), /*#__PURE__*/React.createElement(TeamNames, {
    "data-sentry-element": "TeamNames",
    "data-sentry-source-file": "MatchRowTeaser.tsx"
  }, /*#__PURE__*/React.createElement(TeamName, {
    variant: "caption1",
    "data-sentry-element": "TeamName",
    "data-sentry-source-file": "MatchRowTeaser.tsx"
  }, match.homeTeam.getNameWithMaxLength('middle', 12)), /*#__PURE__*/React.createElement(TeamName, {
    variant: "caption1",
    "data-sentry-element": "TeamName",
    "data-sentry-source-file": "MatchRowTeaser.tsx"
  }, match.awayTeam.getNameWithMaxLength('middle', 12))));
}